
export const serverAppConfig = {
  "storeId": "63fdd492c6ac1db1775617fc",
  "categories": [
    {
      "id": "63fdd8442b07592356572b64",
      "name": "granditude commerce",
      "slug": "commerce",
      "description": "Granditude offers a complete ecosystem of products to help eCommerce businesses streamline operations, optimize prices, and grow revenue. Aurora, a digital assistant that uses machine learning to provide valuable insights into competitors, products, and sales. The Price Optimization tool allows businesses to stay ahead by comparing prices to competitors and adjusting for maximum profitability. Product Information Management (PIM) keeps product data organized and up-to-date, while Grand Connect allows integration with third-party systems. Storefront is a fully customizable storefront, and Order Management makes it easy to manage orders. Granditude is committed to providing the best products and support to customers.",
      "thumbnailDescription": "Discover the power of Granditude's Commerce Eco-System, featuring a range of advanced products such as Price Optimisation, Product Information Management, Aurora, Storefront, Storefront Admin, Grand Connect, and Order Management. With our innovative tools, you can streamline your e-commerce operations and elevate your customer experience to new heights.",
      "additionalText": "<p>At Granditude, we understand that running a successful e-commerce business requires more than just a great product. That&apos;s why we&apos;ve created a comprehensive suite of tools to help you optimize your operations and enhance your customer experience. Our Granditude Commerce Eco System includes a range of products designed to streamline your e-commerce operations and improve your bottom line.</p>\n<p><br></p>\n<p>Our price optimization tool is perfect for businesses looking to maximize their profits. With advanced algorithms and real-time data, you can ensure your pricing strategy is always competitive and effective. Our product information management tool makes it easy to manage your inventory, product descriptions, and more, ensuring that your customers always have accurate and up-to-date information.</p>\n<p><br></p>\n<p>For businesses looking to take their e-commerce experience to the next level, we offer Aurora - a powerful e-commerce assistant that integrates seamlessly with our other products to provide a comprehensive e-commerce solution. Our storefront and storefront admin tools make it easy to create and manage your online store, while our Grand Connect tool allows you to integrate with a wide range of third-party services.</p>\n<p><br></p>\n<p>And of course, our order management tool ensures that you can efficiently process and fulfill customer orders, providing a seamless experience from start to finish. So why wait? Discover the power of the Granditude Commerce Eco System today and take your e-commerce business to the next level.</p>\n<p><br></p>",
      "imgUrl": "https://storage.googleapis.com/gecko-media/GRDT/tags/ecosystem logo pad-01.png",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/GRDT/tags/ecosystem logo pad-01.png",
      "order": 1,
      "metaTitle": "Granditude Commerce Eco System - Products for Price Optimisation, Product Information Management, Aurora, Storefront, and More",
      "metaDescription": "Explore our Granditude Commerce Eco-System products, including price optimisation, product information management, Aurora, storefront, storefront admin, Grand connect, and order management. Streamline your e-commerce operations and enhance your customer experience with our cutting-edge tools.\n",
      "metaHeader": "Discover Our Comprehensive Suite of Granditude Commerce Eco System Products",
      "subCategories": [
        {
          "id": "64185d257a4a3a3e5742b35c",
          "name": "price optimisation",
          "slug": "pricing",
          "description": "As an e-commerce business owner, staying competitive in the market is important by offering the best prices to your customers. This is where Granditude comes in - our price optimisation tool is designed to help you compare your prices to your competitors and stay ahead of the game.\nWith Granditude, you can easily analyze the pricing trends of your competitors and adjust your prices for maximum profitability. Our software uses advanced algorithms to provide you with real-time pricing data and alerts, so you can quickly respond to market changes and stay ahead of the competition.\nOur user-friendly interface makes it easy to input your product information and compare your prices to others in the market. You can also create customized reports to track your pricing performance over time.\nWhat sets Granditude apart is our commitment to providing personalized support to our customers. Our team of experts will work with you to understand your business needs and help you make the most of our software. We believe that our success is tied to the success of our customers, which is why we are dedicated to providing the best possible service.\nIn addition to our price optimisation tool, Granditude also offers a range of other features to help e-commerce businesses grow and succeed. From Product Information Management system (PIM) to Store Front (webshop), our all-in-one ecosystem has everything you need to streamline your operations and increase your revenue.\nDon’t let your prices hold you back - try Granditude Price Optimisation today and start optimising your prices for maximum profitability. Our powerful software and personalized support will help you stay ahead of the competition and take your e-commerce business to the next level.",
          "thumbnailDescription": "Improve your online presence with Granditude Commerce Eco System's Storefront Solutions. Our suite of services, including Price optimization, PIM, Aurora, Grand Connect, and Order Management, are crafted to create an engaging storefront that boosts sales and customer loyalty. Contact us today to discover more!",
          "additionalText": "Granditude Commerce Eco System provides a comprehensive solution for price optimisation. Our suite of products and services, including Product Information Management (PIM), Aurora, Storefront, Storefront Admin, Grand Connect, and Order Management, are designed to help you manage your prices effectively and efficiently. Whether you're a small business or a large corporation, our experts will work with you to develop a customized price optimisation strategy that meets your specific needs and goals.\n\nWith our PIM solution, you can easily manage your product data and ensure that your pricing is accurate and up-to-date. Our Aurora platform enables you to monitor market trends and adjust your prices accordingly, while our Storefront and Storefront Admin tools allow you to create an engaging online store that drives conversions. Grand Connect helps you streamline your pricing processes by integrating with your existing systems, while our Order Management system ensures that your prices are always accurate and consistent.\n\nAt Granditude Commerce Eco System, we are committed to helping you achieve your pricing goals. Our team of experts has years of experience in price optimisation and will work closely with you to develop a strategy that maximizes your profits and customer satisfaction. Contact us today to learn more about our price optimisation services and how we can help you grow your business.\n",
          "imgUrl": "https://storage.googleapis.com/gecko-media/GRDT/tags/price optimisation hero-01.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/GRDT/tags/Artboard 1123.png",
          "order": 3,
          "metaTitle": "Price optimisation in Granditude Commerce Eco System - Product Information Management, Aurora, Storefront, and More",
          "metaDescription": "Discover the power of price optimisation with Granditude Commerce Eco System! We offer a range of products and services, including Product Information Management (PIM), Aurora, Storefront, Storefront Admin, Grand Connect, and Order Management. Our experts will help you optimise your prices for maximum profitability and customer satisfaction. Contact us today!",
          "metaHeader": "Price optimisation Services in Granditude Commerce Eco System - optimise Your Prices with Granditude's amazing tool",
          "subCategories": null
        },
        {
          "id": "641866887a4a3a3e5742b35e",
          "name": "storefront",
          "slug": "storefront",
          "description": "",
          "thumbnailDescription": "Elevate your online presence with Granditude Commerce Eco System's Storefront Solutions! Our Price Optimization, Product Information Management (PIM), Aurora, Grand Connect, and Order Management services help build a captivating storefront, driving sales and customer loyalty. Get in touch to know more!",
          "additionalText": "<p>The storefront is the online face of your business, where customers can browse and purchase products. Granditude&apos;s storefront is designed to be user-friendly and easy to navigate. It features a responsive design that adapts to different screen sizes, ensuring a seamless shopping experience for customers on desktop, tablet, or mobile devices.</p>\n<p><br></p>\n<p>The storefront admin is the back-end interface that enables merchants to manage their online store. It allows merchants to customize the look and feel of their site, handle shipping options and services connected to product level, etc. Granditude&apos;s storefront admin is designed to be intuitive and user-friendly, making it easy for merchants to manage their e-commerce business without the need for technical expertise.</p>\n<p><br></p>\n<p>Together, Granditude&apos;s PIM system, storefront, and storefront admin provide a comprehensive e-commerce solution that enables merchants to efficiently manage their online store and provide a seamless shopping experience for their customers.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/GRDT/tags/storefront hero.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/GRDT/tags/storefront.png",
          "order": 1,
          "metaTitle": "Storefront Solutions in Granditude Commerce Eco System - Price Optimisation, Product Information Management, and More",
          "metaDescription": "Enhance your online presence with Storefront Solutions from Granditude Commerce Eco System! Our suite of products and services, including Price optimisation, Product Information Management (PIM), Aurora, Grand Connect, and Order Management, are designed to help you create a compelling storefront that drives sales and customer loyalty. Contact us today to learn more!",
          "metaHeader": "Storefront Services in Granditude Commerce Eco System - optimise Your Online Presence with Price optimisation, PIM, Aurora, Grand Connect, and Order Management",
          "subCategories": null
        },
        {
          "id": "6419dd4a7a4a3a3e5742b365",
          "name": "product information",
          "slug": "product-info",
          "description": "",
          "thumbnailDescription": "Boost your online presence with Storefront Solutions from Granditude Commerce Eco System! Our suite of tools, such as Price optimization, PIM, Aurora, Grand Connect, and Order Management, are crafted to build a persuasive storefront that boosts sales and customer loyalty. Contact us now to know more!",
          "additionalText": "Granditude's Product Information System is the ultimate tool for e-commerce businesses seeking to streamline their product management workflows. Our cutting-edge system allows you to manage all aspects of your product data, from pricing to descriptions and images, all in one place. With our easy-to-use interface and customizable fields, you can quickly and efficiently optimize your product data for maximum sales potential.\n\nOur system integrates seamlessly with the other products in the Granditude Commerce Eco System, including Price Optimization, Storefront, Aurora, Grand Connect, and Order Management, allowing you to manage your entire e-commerce operation from one place. Whether you're looking to optimize your pricing strategy, manage your storefront, or analyze sales data, Granditude has you covered.\n\nWith Granditude's Product Information System, you can streamline your product data management, enhance your workflows, and boost your online sales. Try it out today and see the difference it can make for your e-commerce business.\n",
          "imgUrl": "https://storage.googleapis.com/gecko-media/GRDT/tags/product information hero-01.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/GRDT/tags/Product Information logo-01.png",
          "order": 4,
          "metaTitle": "Granditude Product Information System - Advanced E-commerce Solution",
          "metaDescription": "Gain an edge in the competitive e-commerce market with Granditude's Product Information System. Enhance your product data, streamline workflows, and boost conversions.",
          "metaHeader": "Optimize Your Online Store with Granditude's Product Information System",
          "subCategories": null
        },
        {
          "id": "6419dd5c7a4a3a3e5742b366",
          "name": "connect",
          "slug": "connect",
          "description": "",
          "thumbnailDescription": "Transform your online presence with Granditude Commerce Eco System's Storefront Solutions. Our suite of services and products, including Product Information Management (PIM), Price Optimization, Order Management, Aurora, and Grand Connect, are tailored to help you build a storefront that increases sales and customer loyalty. Get in touch with us today to discover more!",
          "additionalText": "Are you tired of manually entering data into different software systems for your e-commerce business? Grand Connect can help. As an integral part of the Granditude Commerce Eco System, Grand Connect offers a centralized location for businesses to manage all their integrations. With Grand Connect, you can seamlessly connect with marketplaces, payment providers, and shipping carriers, streamlining your business operations and saving time.\n\nThe open APIs of Grand Connect allow for easy customization and integration with existing software systems. This versatile tool can adapt to your unique business needs, making it an essential tool for any e-commerce business looking to improve efficiency and reduce friction.\n\nDon't waste any more time manually entering data. Try Grand Connect today and see how it can transform your e-commerce operations.",
          "imgUrl": "https://storage.googleapis.com/gecko-media/GRDT/tags/connect hero-01.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/GRDT/tags/Artboard 11.png",
          "order": 5,
          "metaTitle": "Seamless E-commerce Integrations with Grand Connect | Granditude Commerce",
          "metaDescription": "Grand Connect is the essential integration hub for the Granditude Commerce Eco System. With open APIs, it connects your e-commerce business to third-party services such as marketplaces, payment providers, and shipping carriers, streamlining your operations and saving time.",
          "metaHeader": "Streamline Your E-commerce Operations with Grand Connect Integration Hub",
          "subCategories": null
        },
        {
          "id": "64219f126056e91fff3991c0",
          "name": "aurora",
          "slug": "aurora",
          "description": "",
          "thumbnailDescription": "Transform your online business with Granditude's Storefront Solutions! Our suite of products, such as Price Optimization, PIM, Aurora, Grand Connect, and Order Management, empower you to create a captivating storefront that drives customer loyalty and boosts sales. Connect with us now to explore the possibilities!",
          "additionalText": "Aurora is just one of the powerful tools available in Granditude's Commerce Eco System. Along with Price Optimisation, Storefront, Storefront Admin, Product information management, Grand connect, and order management, Aurora can help you optimise every aspect of your e-commerce business. Start using Aurora today and see the difference it can make for your business.",
          "imgUrl": "https://storage.googleapis.com/gecko-media/GRDT/tags/aurora hero-01.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/GRDT/tags/aurora logo-01.png",
          "order": 2,
          "metaTitle": "Improve Your E-commerce Business with Aurora by Granditude",
          "metaDescription": "Looking for a powerful AI assistant to take your e-commerce business to the next level? Look no further than Granditude's Aurora. With advanced machine learning algorithms and a powerful dashboard, Aurora provides valuable insights into your competitors, products, and sales, helping you make data-driven decisions and drive growth.",
          "metaHeader": "Discover the Power of Aurora - Granditude's AI Assistant for E-commerce",
          "subCategories": null
        },
        {
          "id": "64219f286056e91fff3991c1",
          "name": "order management",
          "slug": "order-man",
          "description": "",
          "thumbnailDescription": "Boost your online presence with Granditude's Storefront Solutions! Our products and services, like Price Optimization, PIM, Aurora, Grand Connect, and Order Management, help create a captivating storefront that drives sales and loyalty. Contact us to learn more!",
          "additionalText": "Are you tired of manually managing your e-commerce orders? Look no further than Granditude's Order Management software. Our platform is designed to streamline your e-commerce operations and provide you with all the tools you need to efficiently manage your orders.\n<br><br>\nWith Granditude's Order Management software, you can easily manage and track all of your orders in one centralized location. Our platform provides real-time updates on order status, inventory levels, and shipping information, making it easy to keep track of all your orders.\n<br><br>\nOur software integrates seamlessly with other products in the Commerce Eco System, including Price Optimization, Storefront, Storefront Admin, Product Information Management, Aurora, and Grand Connect. This means that you can manage your entire e-commerce operation from one place, saving you time and reducing the risk of errors.\n<br><br>\nIn addition, our Order Management software is highly customizable, allowing you to tailor it to your specific business needs. With advanced features such as automated order routing, multi-channel selling, and customized order workflows, our platform can help you take your e-commerce business to the next level.\n",
          "imgUrl": "https://storage.googleapis.com/gecko-media/GRDT/tags/order management hero-01.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/GRDT/tags/order management logo-01.png",
          "order": 6,
          "metaTitle": "Order Management Software | Granditude Commerce Eco System",
          "metaDescription": "Take control of your e-commerce orders with Granditude's Order Management software, included in the Commerce Eco System along with Price Optimization, Storefront, Storefront Admin, Product Information Management, Aurora, and Grand Connect.\n",
          "metaHeader": "Streamline Your E-commerce Operations with Granditude's Order Management Software",
          "subCategories": null
        },
        {
          "id": "65001028a3bc6062ac40d379",
          "name": "reach",
          "slug": "reach",
          "description": "Introducing reach by Granditude - your gateway to global eCommerce. In today's diverse market, language should never be a barrier. With Reach, you can automatically translate and generate product content tailored for audiences worldwide. Whether it's creating product descriptions or adapting content to resonate with different cultures, Reach ensures your message is clear, consistent, and compelling. Embrace the future of eCommerce and connect with customers on a truly global scale.",
          "thumbnailDescription": "",
          "additionalText": "Introducing reach by Granditude - your gateway to global eCommerce. In today's diverse market, language should never be a barrier. With Reach, you can automatically translate and generate product content tailored for audiences worldwide. Whether it's creating product descriptions or adapting content to resonate with different cultures, Reach ensures your message is clear, consistent, and compelling. Embrace the future of eCommerce and connect with customers on a truly global scale.",
          "imgUrl": "https://storage.googleapis.com/gecko-media/GRDT/tags/reach hero-01.png",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/GRDT/tags/reach logo.png",
          "order": 7,
          "metaTitle": "Reach by Granditude: Multilingual eCommerce Content Automation",
          "metaDescription": "Expand your market effortlessly with Reach. Translate, generate, and optimize product content for a global audience. Dive into multilingual eCommerce with Granditude's innovative solution.",
          "metaHeader": "Unlock Global eCommerce with Reach's Automated Translations",
          "subCategories": null
        }
      ]
    }
  ],
  "analytics": {
    "gtmId": "GTM-W22M694G",
    "destinations": [
      {
        "type": "GTM",
        "id": "GTM-NWKNVQQ",
        "customMapping": null
      }
    ]
  },
  "privacy": {
    "cmpType": "COOKIE_SCRIPT",
    "cmpId": "7662925ba3987d26e22898d8aa06cc98"
  },
  "storeType": "B2C",
  "storeDeliveries": [
    {
      "id": "64186d1ba402aa2aa48d6019",
      "name": "1-2 weeks",
      "label": "1-2 weeks",
      "buyable": true
    }
  ],
  "language": "en",
  "currency": "SEK",
  "labels": {
    "assistantChatWith": "Chat with",
    "assistantChatWithFallback": "Customer",
    "assistantShrink": "Shrink",
    "assistantExpand": "Expand",
    "assistantMinimize": "Minimize",
    "assistantReply": "Reply",
    "assistantStatusSent": "Sent",
    "assistantErrorServiceUnavailable": "Service unavailable",
    "assistantErrorUndelivered": "Undelivered",
    "assistantConversationStatusRecording": "Listening...",
    "assistantConversationStatusProcessing": "Processing...",
    "assistantConversationStatusProcessingResponse": "Preparing response...",
    "assistantConversationStatusProcessingResponding": "Responding...",
    "assistantConversationStatusError": "Something went wrong",
    "changePwdFormMsg": "At least 6 characters, including an uppercase letter, a lowercase letter, and a number.",
    "changePwdFormOldPwd": "Old password",
    "changePwdFormOldPwdRequired": "Old password is required.",
    "changePwdFormNewPwd": "New password",
    "changePwdFormNewPwdInvalid": "Password must be at least 6 characters and include an uppercase letter, a lowercase letter, and a number.",
    "changePwdFormRepeatPwd": "Repeat password",
    "changePwdFormRepeatPwdMismatch": "Passwords do not match.",
    "changePwdFormBtnLabel": "Save",
    "changePwdFormBtnLoading": "Saving…",
    "loginFormBtnLoading": "Signing in…",
    "loginFormEmailInvalid": "Enter a valid email address.",
    "loginFormPwdRequired": "Password is required.",
    "loginPageSubtitle": "Log in to view your orders and manage your profile.",
    "loginPageNewHere": "New here?",
    "signupFormBtnLoading": "Registering…",
    "signupFormEmailInvalid": "Enter a valid email address.",
    "signupFormFirstNameRequired": "First name is required.",
    "signupFormLastNameRequired": "Last name is required.",
    "signupPageSubtitle": "Register to follow orders and manage your details.",
    "signupAlreadyHaveAccount": "Already have an account?",
    "magicLinkFormBtnLoading": "Sending…",
    "magicLinkFormEmailInvalid": "Enter a valid email address.",
    "newPasswordPageSubtitle": "Enter your email address and we'll send you a reset link.",
    "newPasswordPageSuccess": "If the email exists in our system, a reset link has been sent to it.",
    "loginForgottenPwd": "Forgotten password?",
    "loginForgottenPwdDesc": "An account is created automatically for you when you place your first order and instructions sent with your order confirmation.",
    "toLogin": "Back to login",
    "requestPwd": "Request new password",
    "accountRegistration": "To be able to follow this and other orders more easily, you can create a password for the account.",
    "contactUsFormName": "Name",
    "contactUsFormPhone": "Phone",
    "contactUsFormEmail": "Email",
    "contactUsFormOrderDate": "Order date",
    "contactUsFormProduct": "Product",
    "contactUsFormOrderNumber": "OrderNumber",
    "contactUsFormDescription": "Description",
    "contactUsFormLocation": "Location",
    "contactUsFormBtnLabel": "Send",
    "contactUsFormAttachFiles": "Attach files",
    "contactConfirmationMessage": "Thank you for submitting your request! We will contact you as soon as possible.",
    "discountFormName": "Do you want to add a discount code?",
    "discountFormBtnLabel": "Add discount",
    "discountFormCodePlaceholder": "Discount code",
    "discountFormErrorNotFound": "Invalid discount code",
    "loginPageTitle": "Log in",
    "loginFormEmail": "Email",
    "loginFormPwd": "Password",
    "loginFormBtnLabel": "Login",
    "magicLinkFormEmail": "Email",
    "magicLinkFormBtnLabel": "Email",
    "profileFormFirstName": "First name",
    "profileFormMiddleName": "Middle name",
    "profileFormLastName": "Last name",
    "profileFormOrganizationName": "Organization name",
    "profileFormGender": "Gender",
    "profileFormDateOfBirth": "Birthdate",
    "profileFormBtnLabel": "Send",
    "logout": "Logout",
    "accountUserGreeting": "Welcome",
    "accountHandlerAccountTitle": "Account",
    "accountHandlerOrdersTitle": "Orders",
    "accountHandlerProfileTitle": "Profile",
    "accountHandlerChangePasswordTitle": "Change password",
    "customerOrderOrderNumber": "Order number",
    "customerOrderPaymentDate": "Payment date",
    "customerOrderStatus": "Status",
    "customerOrderShippingCost": "Shipping cost",
    "customerOrderDiscount": "Discount",
    "customerOrderAmount": "Amount",
    "customerOrderDetailInformation": "Information",
    "customerOrderDetailDeliveryAddress": "Delivery address",
    "customerOrderDetailAddress": "Address",
    "customerOrderDetailPostalCode": "Post code",
    "customerOrderDetailAttention": "Attention",
    "customerOrderDetailMobile": "Mobile",
    "customerOrderDetailYourOrder": "Your order",
    "customerOrderDetailPcs": "pcs",
    "noOrdersMessage": "No orders found",
    "noOrdersBtnLabel": "Continue shopping",
    "emptyCart": "No items found",
    "cartServiceShowDetails": "Show details",
    "cartServiceHideDetails": "Hide details",
    "allCategoriesTitle": "All categories",
    "subcategoriesShowMoreBtnLabel": "More",
    "subcategoriesNoCategories": "No categories found",
    "subcategoriesToolbarTitle": "Categories",
    "allCategoriesListDynamic": "Category",
    "checkoutNewsLetter": "Feel free to subscribe to our newsletter to receive updates about our products and special offers: ",
    "newsLetterInputLabel": "Your email",
    "emptyCartBtnLabel": "Start shopping",
    "continueShopping": "Continue shopping",
    "checkoutCartCartItemsMsg": "products in cart",
    "checkoutPageTitle": "Checkout",
    "checkoutServicesHeading": "Services",
    "addToCart": "Add to cart",
    "noServices": "No services",
    "cartTotal": "Cart total",
    "cartToCheckout": "Cart checkout",
    "checkoutSummaryDiscount": "Discount",
    "checkoutSummarySummaryItemProducts": "Products",
    "checkoutSummarySummaryItemServices": "Services",
    "checkoutSummaryCompletePayment": "Complete payment",
    "checkoutSummaryNoProducts": "No products found in the cart",
    "checkoutSummaryDiscountMsg": "Important: If the price of the item is already discounted, it can only have an effect on the original price of the item.",
    "checkoutSummarySummaryTotal": "Total",
    "checkoutSummarySummaryTotalDiscount": "Total discount",
    "checkoutSummaryQuantityDiscount": "Quantity discount",
    "quantityDiscountTeaser": "Buy {{nextQty}} and save {{nextPercentage}} on your whole order.",
    "quantityDiscountTeaserPack": "Buy {{nextQty}} and save {{nextPercentage}} on every pack.",
    "quantityDiscountProgress": "Add {{unitsToNext}} more and save {{nextPercentage}} on your whole order.",
    "quantityDiscountProgressPack": "Add {{unitsToNext}} more to get {{nextPercentage}} off another {{nextQty}}.",
    "quantityDiscountAchieved": "You save {{currentPercentage}} on this item.",
    "quantityDiscountSavingPerUnit": "You save {{nextSaving}}/{{unit}}",
    "quantityDiscountUnitAbbr": "pcs",
    "checkoutSummarySummaryVat": "VAT",
    "checkoutSummarySummaryNetTotal": "Subtotal excl. VAT",
    "checkoutSummarySummaryContinueToPayment": "Continue to payment",
    "checkoutSummaryCountryLabel": "Country",
    "checkoutDeliveryStep": "Delivery",
    "checkoutPaymentStep": "Complete your order",
    "confirmationPageRedirectBtnLabel": "My pages",
    "confirmationPageUnknownError": "Unknown error",
    "orderIdNotFound": "Order ID not found",
    "klarnaBackToCart": "Back to cart",
    "productFilesFileLabel": "document",
    "updateCart": "Update",
    "productDetailDeliveryLabelUnavailable": "not available",
    "previousPageBtnLabel": "go back",
    "productRequest": "Product request",
    "productListItemBuyToDetails": "Go to detail",
    "productNotActive": "This product is not active",
    "articleNumber": "Article Number",
    "gtin": "GTIN",
    "brand": "Brands",
    "brandsTitle": "Brands",
    "stockLevel": "Stock level",
    "unit": "units",
    "productTabsDescriptionTitle": "Description",
    "productTabsSpecificationTitle": "Specification",
    "productTabsAttachedFilesTitle": "Attached files",
    "productTabsNoDescription": "No description",
    "productTabsReviewsTitle": "Reviews",
    "notInStock": "Not available in stock",
    "noMedias": "No photos",
    "withMedias": "See photos",
    "accessories": "Accessories",
    "variants": "Variants",
    "variantNotFound": "Variant not found",
    "showMoreBtnLabel": "More",
    "priceTitle": "Price",
    "moreFiltersTitle": "More",
    "reset": "Reset filters",
    "cleanFilters": "Clean",
    "search": "Search",
    "sort": "Sort",
    "showMoreFilters": "Show more filters",
    "filterTitle": "Filter",
    "filterCategoriesTitle": "Category",
    "filterBrandsTitle": "Brand",
    "filterPriceRangeTitle": "Price",
    "filterClear": "Reset filters",
    "filterSubmitText": "Show products",
    "filterRangeSelectorFrom": "From",
    "filterRangeSelectorTo": "to",
    "productListVerticalTitle": "Sort and filter",
    "productListSearchTitle": "Sort and filter",
    "viewTotalProducts": "see products",
    "noProductsFound": "No products found",
    "removeFilter": "Remove filter",
    "uniqueOption": "Unique",
    "notValuesFound": "No values found",
    "sortAndFilter": "Sort and filter",
    "dropzoneDropMsg": "Drop your files here or click to upload",
    "dropzoneAcceptedFiles": "Accepted files",
    "dropzoneReadyMsg": "Ready to upload",
    "dropzoneRejectedMsg": "Rejected files",
    "prisFilterTitle": "Price",
    "searchPlaceholder": "Search products",
    "followUs": "Follow us",
    "searchPanelCloseSearch": "Close search",
    "searchPanelOpenSearch": "Open search",
    "searchPopularResults": "Popular results:",
    "registerAccount": "Register",
    "signupFormEmail": "Email",
    "signupFormFirstName": "First name",
    "signupFormLastName": "Last name",
    "signupFormBtnLabel": "Signup",
    "signUpSuccessMsg": "The account has been registered, you will receive an email shortly with instructions.",
    "signUpErrorMsgRecoverPassword": "Have you lost your password? Recover it ",
    "signupRecoverPasswordLink": "here",
    "signupInvalidCredentials": "Invalid credentials",
    "marketplaceProductsIsAvailable": "Available",
    "marketplaceProductsIsNotAvailable": "Not available",
    "marketplaceProductsShowMore": "Show more",
    "marketplaceProductsShowLess": "Show less",
    "marketplaceProductsNoVendorsFound": "No vendors found",
    "showAll": "Show all",
    "seeAll": "See all",
    "requestSent": "Request sent",
    "mobileMenuMultiColumnBack": "Back",
    "mobileMenuMultiColumnSearchPlaceholder": "Search for product or service",
    "checkoutRemoveDiscountCode": "Remove discount code",
    "quantity": "Quantity",
    "assistantChat": "Chat",
    "assistantOffers": "Deals",
    "vatToggleIncludedLabel": "Incl. VAT",
    "vatToggleExcludedLabel": "Excl. VAT",
    "vatToggleBusinessPricingLabel": "Business pricing",
    "accountSignInLabel": "Sign in",
    "accountMyAccountFallback": "My account",
    "accountMyPages": "My orders",
    "accountProfile": "Profile",
    "accountLogout": "Log out",
    "accountNewHere": "New here?",
    "accountCreateAccount": "Create account",
    "accountViewPricesHeading": "View prices",
    "accountBusinessBadge": "Business account",
    "ordersListTitle": "All orders",
    "ordersListRangeOf": "of",
    "ordersListEmpty": "You don't have any orders yet.",
    "ordersListError": "We could not load your orders right now. Please try again later.",
    "ordersListEmptyCta": "Continue shopping",
    "ordersListItemQuantity": "Qty:",
    "ordersListItemMore": "more",
    "ordersListOrderIdPrefix": "Order ID:",
    "ordersListDetailsCta": "View details →",
    "ordersListPlacedBy": "Placed by",
    "ordersListPlacedByUnknown": "Unknown",
    "orderDetailBack": "← Back to orders",
    "orderDetailOrderedOn": "Ordered",
    "orderDetailOrderedOnBy": "by",
    "orderDetailPlacedByUnknown": "Unknown",
    "orderDetailShippingAddress": "Shipping address",
    "orderDetailBillingAddress": "Billing address",
    "orderDetailProductsHeading": "Products",
    "orderDetailShipping": "Shipping",
    "orderDetailDiscount": "Discount",
    "orderDetailTotal": "Total",
    "orderDetailVatIncluded": "Of which VAT",
    "orderDetailShipmentsHeading": "Shipments",
    "orderDetailShipmentTracking": "Tracking",
    "orderDetailShipmentPickup": "Pickup location",
    "orderDetailShipmentEstimated": "Estimated delivery",
    "orderDetailShipmentShipped": "Shipped",
    "orderDetailShipmentDelivered": "Delivered",
    "orderDetailShipmentItems": "Items",
    "orderDetailProductUnavailable": "No longer available",
    "profileFormSectionTitle": "Personal details",
    "profileFormFirstNameLabel": "First name",
    "profileFormFirstNameRequired": "First name is required",
    "profileFormMiddleNameLabel": "Middle name",
    "profileFormLastNameLabel": "Last name",
    "profileFormLastNameRequired": "Last name is required",
    "profileFormOrganizationNameLabel": "Organization name",
    "profileFormDateOfBirthLabel": "Date of birth",
    "profileFormGenderLabel": "Gender",
    "profileFormGenderPlaceholder": "Select…",
    "profileFormGenderFemale": "Female",
    "profileFormGenderMale": "Male",
    "profileFormGenderUndefined": "Prefer not to say",
    "profileFormEmailLabel": "Email",
    "profileFormPhoneLabel": "Phone",
    "profileFormPhonePlaceholder": "+46…",
    "profileFormPhoneInvalid": "Enter a valid phone number.",
    "profileFormSubmit": "Save",
    "profileFormSubmitLoading": "Saving…",
    "profileFormSuccess": "Profile updated",
    "profileFormGenericError": "Something went wrong",
    "changePasswordFormSectionTitle": "Change password",
    "changePasswordFormOldLabel": "Current password",
    "changePasswordFormOldRequired": "Current password is required",
    "changePasswordFormNewLabel": "New password",
    "changePasswordFormNewDescription": "At least 6 characters, including an uppercase letter, a lowercase letter, and a number.",
    "changePasswordFormNewInvalid": "Password must be at least 6 characters and include an uppercase letter, a lowercase letter, and a number.",
    "changePasswordFormConfirmLabel": "Confirm new password",
    "changePasswordFormConfirmRequired": "Confirm the new password",
    "changePasswordFormMismatch": "Passwords do not match",
    "changePasswordFormMissingEmail": "Logged-in account is missing an email",
    "changePasswordFormSubmit": "Update password",
    "changePasswordFormSubmitLoading": "Updating…",
    "changePasswordFormSuccess": "Password updated",
    "changePasswordFormGenericError": "Something went wrong",
    "paginationPrev": "Previous",
    "paginationNext": "Next",
    "accountSidebarLogout": "Log out",
    "accountNavOrders": "Orders",
    "accountNavProfile": "Profile",
    "accountNavPassword": "Password",
    "accountMetaOrdersTitle": "My orders",
    "accountMetaOrderDetailTitle": "Order",
    "accountMetaProfileTitle": "Profile",
    "accountMetaPasswordTitle": "Password",
    "ordersListItemShowLess": "Show less",
    "orderDetailShipmentPickedUp": "Picked up",
    "orderDetailPaymentInvoiced": "Invoice",
    "orderDetailPaymentVia": "Paid via",
    "paymentProviderKlarna": "Klarna",
    "paymentProviderNexi": "Nexi",
    "paymentProviderSvea": "Svea",
    "paymentProviderLedyer": "Ledyer",
    "paymentProviderQliro": "Qliro",
    "paymentProviderBriqpay": "Briqpay",
    "orderStatusDraft": "Draft",
    "orderStatusCreated": "Created",
    "orderStatusPaid": "Paid",
    "orderStatusProcessing": "Processing",
    "orderStatusReady": "Ready",
    "orderStatusPartiallyDelivered": "Partially delivered",
    "orderStatusDelivered": "Delivered",
    "orderStatusPartiallyReturned": "Partially returned",
    "orderStatusReturned": "Returned",
    "orderStatusCancelled": "Cancelled",
    "orderStatusSettled": "Settled",
    "shipmentStatusCreated": "Created",
    "shipmentStatusProcessing": "Processing",
    "shipmentStatusShipped": "Shipped",
    "shipmentStatusDelivered": "Delivered",
    "shipmentStatusBlocked": "Blocked",
    "shipmentStatusCancelled": "Cancelled",
    "shipmentStatusDeleted": "Deleted",
    "invoiceBillingFieldFirstName": "First name",
    "invoiceBillingFieldLastName": "Last name",
    "invoiceBillingFieldEmail": "Email",
    "invoiceBillingErrorRequired": "Required field",
    "invoiceBillingErrorEmail": "Invalid email address",
    "confirmationSummaryHeading": "Your order",
    "confirmationSummaryQuantity": "Quantity",
    "confirmationSummaryShipping": "Shipping",
    "confirmationSummaryShippingFree": "Free shipping",
    "confirmationSummaryDiscount": "Discount",
    "confirmationSummaryVat": "Of which VAT",
    "confirmationSummaryTotal": "Total",
    "confirmationSummaryShippingAddress": "Delivery address",
    "confirmationSummaryPickup": "Pickup location",
    "confirmationSummaryTracking": "Track your shipment",
    "confirmationSummaryPaymentMethod": "Payment method",
    "briqpayConfirmationTitle": "Thank you for your order!",
    "briqpayConfirmationOrderNumberPrefix": "Order number: ",
    "briqpayConfirmationPending": "Your payment is being processed and will be confirmed shortly.",
    "confirmationSummaryReceiptEmail": "Email",
    "invoiceBillingErrorPhone": "Invalid phone number",
    "currency": "SEK",
    "priceCurrency": "SEK"
  },
  "paths": {
    "brandsUrlPath": "/varumarken",
    "categoriesUrlPath": "/categories",
    "tagsUrlPath": "/t",
    "productsUrlPath": "/p",
    "blogsUrlPath": "/blog"
  },
  "staticLinks": [
    {
      "id": "blog",
      "label": "Stories",
      "path": "/blog"
    }
  ],
  "logoUrl": "",
  "showCart": true,
  "sortingOptions": [
    {
      "sortBy": "price",
      "sortOrder": "DESC",
      "sortLabel": "Pris högt-lågt",
      "default": false
    },
    {
      "sortBy": "price",
      "sortOrder": "ASC",
      "sortLabel": "Pris lågt-högt",
      "default": true
    },
    {
      "sortBy": "created",
      "sortOrder": "DESC",
      "sortLabel": "Nyaste",
      "default": false
    }
  ],
  "desktopItemHeight": "20vw",
  "mobileItemHeight": "45vw",
  "maxContentWidth": 1270,
  "menuMaxContentWidth": 1270,
  "sliderDefaultValues": [
    0,
    100000
  ],
  "freeShippingOver": 499,
  "shippingProviderConfig": {
    "provider": "DEFAULT",
    "simpleShipping": {
      "minimumOrderAmountForFreeDelivery": 499,
      "deliveryFee": 139
    }
  },
  "paymentProviderConfig": {
    "providerName": "KLARNA",
    "providerOptions": {
      "klarna": {
        "purchaseCurrency": "SEK"
      }
    }
  },
  "filtersBeforeShowMore": 3,
  "sliderMaxPrice": 100000,
  "topNavHeight": {
    "panel": {
      "base": 0,
      "sm": 0
    },
    "content": {
      "base": "8vh",
      "sm": "14vh"
    },
    "spacer": {
      "base": "8vh",
      "sm": "14vh"
    }
  },
  "topNavSlideOutFeaturedCategories": 3,
  "socialMediaItems": [
    {
      "label": "Facebook",
      "icon": "FACEBOOK",
      "href": "https://www.facebook.com/granditude/?locale=sv_SE"
    },
    {
      "label": "Instagram",
      "icon": "INSTAGRAM",
      "href": "https://www.instagram.com/granditude/?hl=en"
    }
  ]
};
export const serverTheme = {}; 
